import { cn } from "@/lib/utils";

type EdgeCareBrandProps = {
  className?: string;
  markClassName?: string;
};

export function EdgeCareBrand({
  className,
  markClassName,
}: EdgeCareBrandProps) {
  return (
    <div
      className={cn("flex items-center gap-2", className)}
      aria-label="EdgeCare"
    >
      <img
        src="/playstore-icon.png"
        alt=""
        className={cn("size-8 shrink-0 object-contain", markClassName)}
        aria-hidden="true"
      />
      <span className="text-base font-semibold tracking-tight text-[#102856]">
        EdgeCare
      </span>
    </div>
  );
}
